// src/components/About.js
import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import readytomove from "../../images/readytomove.jpg";
import township from "../../images/township.jpg";
import luxury from "../../images/luxury.jpg";
import forBachelors from "../../images/forBachelors.jpeg";
import greatCommute from "../../images/greatCommute.jpeg";
import ownerFlats from "../../images/ownerFlats.jpeg";
import cornerPlots from "../../images/cornerPlots.jpeg";
import eastFacingPlots from "../../images/eastFacingPlots.jpeg";
import boundryWallPlots from "../../images/boundryWallPlots.jpeg";
import itHub from "../../images/it_hub.png";
import educationHub from "../../images/education_hub.png";
import financeHub from "../../images/finance_hub.png";
const FeaturedCollection = ({
  category,
  title = "Handpicked Projects For You ",
}) => {
  const sliderRef = useRef(null);
  const sellerRef = useRef(null);

  // Define feature categories for different property sections
  const featureCategories = {
    buy: [
      {
        name: "Ready to Move-In",
        link: "/buy/searches/ready_to_moves-for-sale-in-jaipur-rajasthan-srcid-1",
        localStorageKey: "construction_status:ready_to_move",
        backgroundImage: `url(${readytomove})`,
      },
      {
        name: "More Than 5 BHK",
        link: "/buy/searches/5bhk+s-for-sale-in-jaipur-rajasthan-srcid-1",
        localStorageKey: "bhk_type:5bhk+",
        backgroundImage: `url(${township})`,
      },
      {
        name: "Owner",
        link: "/buy/searches/owners-for-sale-in-jaipur-rajasthan-srcid-1",
        localStorageKey: "selfType:owner",
        backgroundImage: `url(${luxury})`,
      },
    ],
    living: [
      {
        name: "FOR GUYS",
        link: "/living/searches/boys-for-rent-in-jaipur-rajasthan-srcid-1",
        localStorageKey: "gender:boy",
        backgroundImage: `url(${readytomove})`,
      },
      {
        name: "FOR GIRLS",
        link: "/living/searches/girls-for-rent-in-jaipur-rajasthan-srcid-1",
        localStorageKey: "gender:girl",
        backgroundImage: `url(${township})`,
      },
      {
        name: "PRIVATE ROOM",
        link: "/living/searches/privateRooms-for-rent-in-jaipur-rajasthan-srcid-1",
        localStorageKey: "room_type:0",
        backgroundImage: `url(${township})`,
      },
    ],
    commercial: [
      {
        name: "COMMERCIAL",
        link: "/commercial/buy/searches/commercials-for-sale-in-jaipur-rajasthan-srcid-1",
        localStorageKey: "zone_type:commercial",
        backgroundImage: `url(${itHub})`,
      },
      {
        name: "OPEN SAPCE",
        link: "/commercial/buy/searches/open_spaces-for-sale-in-jaipur-rajasthan-srcid-1",
        localStorageKey: "zone_type:open_space",
        backgroundImage: `url(${educationHub})`,
      },
      {
        name: "INDUSTRIAL",
        link: "/commercial/buy/searches/industrials-for-sale-in-jaipur-rajasthan-srcid-1",
        localStorageKey: "zone_type:industrial",
        backgroundImage: `url(${financeHub})`,
      },
    ],
    rent: [
      {
        name: "EAST FACING FLATS",
        link: "/rent/searches/easts-for-rent-in-jaipur-rajasthan-srcid-1",
        localStorageKey: "facing:east,property_type:apartment",
        backgroundImage: `url(${forBachelors})`,
      },
      {
        name: "BROKER FLATS",
        link: "/rent/searches/brokers-for-rent-in-jaipur-rajasthan-srcid-1",
        localStorageKey: "selfType:broker,property_type:apartment",
        backgroundImage: `url(${greatCommute})`,
      },
      {
        name: "OWNER FLATS",
        link: "/rent/searches/owners-for-rent-in-jaipur-rajasthan-srcid-1",
        localStorageKey: "selfType:owner,property_type:apartment",
        backgroundImage: `url(${ownerFlats})`,
      },
    ],
    plot: [
      {
        name: "CORNER PLOTS",
        link: "/buy/searches/plots-for-sale-in-jaipur-rajasthan-srcid-1",
        localStorageKey: "property_detail:corner_plot,property_type:plots",
        backgroundImage: `url(${cornerPlots})`,
      },
      {
        name: "BOUNDRY WALL PLOTS",
        link: "/buy/searches/plots-for-sale-in-jaipur-rajasthan-srcid-1",
        localStorageKey: "property_detail:boundary_wall,property_type:plots",
        backgroundImage: `url(${eastFacingPlots})`,
      },
      {
        name: "EAST FACING PLOTS",
        link: "/buy/searches/plots-for-sale-in-jaipur-rajasthan-srcid-1",
        localStorageKey: "facing:east,property_type:plot",
        backgroundImage: `url(${boundryWallPlots})`,
      },
    ],
  };

  // Extract selected category's feature items
  const featureStyles = featureCategories[category];

  // Define "View All" links per category
  const viewAll = {
    buy: {
      link: "/buy/searches/flats-for-sale-in-jaipur-rajasthan-srcid-1",
    },
    commercial: {
      link: "/commercial/buy/searches/commerical-property-for-sale-in-jaipur-rajasthan-srcid-1",
    },
    rent: {
      link: "/rent/searches/flats-for-rent-in-jaipur-rajasthan-srcid-1",
    },
    plot: {
      link: "/buy/searches/plots-for-sale-in-jaipur-rajasthan-srcid-1",
      localStorageFeatures: "property_type:plot",
    },
    living: {
      link: "/living/searches/pg-in-jaipur-rajasthan-srcid-1",
    },
  };

  // Extract "View All" link for the current category
  const viewAllLink = viewAll[category];

  const PrevArrow = (props) => {
    const { className, onClick } = props;
    return (
      <button className={`custom-arrow custom-prev`} onClick={onClick}>
        {"<"}
      </button>
    );
  };

  const NextArrow = (props) => {
    const { className, onClick } = props;
    return (
      <button className={`custom-arrow custom-next`} onClick={onClick}>
        {">"}
      </button>
    );
  };

  // Slick slider configuration for the feature slider
  const feature = {
    arrows: false,
    centerMode: true,
    dots: false,
    infinite: true,
    speed: 1000,
    autoplay: true,
    pauseOnHover: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
          arrows: false /* Disable arrows for smaller screens */,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
        },
      },
    ],
  };

  // Function to go to previous slide (used by custom arrow or external control)
  const handlePrevClick = () => {
    if (sliderRef.current) {
      sliderRef.current.slickPrev();
    }
    if (sellerRef.current) {
      sellerRef.current.slickPrev();
    }
  };

  // Function to go to next slide (used by custom arrow or external control)
  const handleNextClick = () => {
    if (sliderRef.current) {
      sliderRef.current.slickNext();
    }
    if (sellerRef.current) {
      sellerRef.current.slickNext();
    }
  };

  return (
    <section className="feature-section sectiontopgap">
      <div className="container">
        <div className="sectiontitle">
          <div className="titleunderline" data-aos="fade-right">
            <svg
              width="64"
              height="3"
              viewBox="0 0 64 3"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2 1.5H62"
                stroke="#F68633"
                stroke-width="3"
                stroke-linecap="round"
              />
            </svg>
          </div>
          <h1>{title}</h1>
        </div>

        <div className="slider-controls">
          <button className="slider-btn prev-btn" onClick={handlePrevClick}>
            ❮
          </button>
          <Link
            to={viewAllLink.link}
            onClick={() => {
              if (viewAllLink.localStorageFeatures) {
                localStorage.setItem(
                  "feature_clicked",
                  viewAllLink.localStorageFeatures
                );
              }
            }}
          >
            <button className="view-all-btn">View All</button>
          </Link>
          <button className="slider-btn next-btn" onClick={handleNextClick}>
            ❯
          </button>
        </div>

        <div className="content content_margin">
          <Slider ref={sliderRef} {...feature}>
            {featureStyles.map((feature, index) => (
              <div className="featureslides" key={index}>
                <Link
                  to={feature.link}
                  onClick={() =>
                    feature.localStorageKey &&
                    localStorage.setItem(
                      "feature_clicked",
                      feature.localStorageKey
                    )
                  }
                >
                  
                  <div className="fslidebox">
                    <div className="fsoverlay"></div>
                    <div
                      className="featurebox"
                      style={{
                        backgroundImage: feature.backgroundImage,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }}
                    ></div>
                    <div className="overlaydata">{feature.name}</div>
                  </div>
                </Link>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default FeaturedCollection;
